<hvac-toast></hvac-toast>

<hvac-login-panel-container *ngIf="loginEnabled && !(isLoggedIn$ | async)"></hvac-login-panel-container>
    <utc-header></utc-header>
<navigation-container *ngIf="isIcp || isTotaline"></navigation-container>

<router-outlet (activate)="pageRouteActivated($event)"></router-outlet>

<utc-footer></utc-footer>
